import Logo from '@cx-web/components/primitives/Logo';

export function ErrorWithTranslation({
  baseUrl,
  rootLoaderData,
  statusLogoPng,
  t,
}: {
  baseUrl: string;
  rootLoaderData: any;
  statusLogoPng: string;
  t: (key: string) => string;
}) {
  return (
    <>
      <div className="textSection" data-testid="errorWithTranslations">
        <img
          alt={t('CX_ERROR_PAGE_INTERNAL_SERVER_ERROR')}
          className="mobileImage"
          data-testid="mobileErrorImage"
          src={`${rootLoaderData?.resourcesUrl ?? ''}/assets/img/${statusLogoPng}`}
        />
        <Logo resourcesUrl={rootLoaderData?.resourcesUrl ?? ''} />
        <div className="oops">{t('CX_ERROR_PAGE_HEADER')}!</div>
        <p className="text">{t('CX_ERROR_PAGE_DESCRIPTION')}.</p>
        <a className="homepage" href={baseUrl}>
          {t('CX_ERROR_PAGE_MAIN_CTA')}
        </a>
        <p className="text">{t('CX_ERROR_PAGE_SUPPORT_TEXT')}?</p>
        <div className="buttonSection">
          <a href={`${baseUrl}/${t('CX_ERROR_PAGE_FREE_BETS_CTA_URL')}`}>{t('CX_ERROR_PAGE_FREE_BETS_CTA_TEXT')}</a>
          {/* TODO: the below needs to change for OC repub to TIPS */}
          <a href={`${baseUrl}/${t('CX_ERROR_PAGE_PICKS_CTA_URL')}`}>{t('CX_ERROR_PAGE_PICKS_CTA_TEXT')}</a>
          <a href={`${baseUrl}/${t('CX_ERROR_PAGE_BETTING_GUIDES_CTA_URL')}`}>
            {t('CX_ERROR_PAGE_BETTING_GUIDES_CTA_TEXT')}
          </a>
        </div>
      </div>
      <img
        alt={t('CX_ERROR_PAGE_INTERNAL_SERVER_ERROR')}
        className="desktopImage"
        data-testid="desktopErrorImage"
        src={`${rootLoaderData?.resourcesUrl ?? ''}/assets/img/${statusLogoPng}`}
      />
    </>
  );
}
